import { IMAGE_FILE } from '@shoflo/polymer/constants/SourceItems';
import { OVERLAY_ADD } from 'store/eventConstants';
import { BROADCAST_CREATE_OVERLAY } from 'actions/Types';
import { UPPER_LEFT, OverlayStyles } from 'constants/LayerPositions';
import { withCurrentParams, mapSignedUrlsToSources } from 'actions/utils';

export default (eventDoc, template) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_CREATE_OVERLAY,
        request: async apiClient => {
          const payload = {
            source: {
              type: IMAGE_FILE,
              title: template.title,
              value: eventDoc._id
            },
            layer: {
              title: UPPER_LEFT,
              style: OverlayStyles[UPPER_LEFT]
            }
          };
          const broadcast = await apiClient.broadcast.createOverlay(
            teamId,
            eventId,
            broadcastId,
            payload
          );
          const { overlays } = broadcast;
          const createdOverlay = overlays.find(
            overlay => overlay.source.value === eventDoc._id
          );
          const mappedOverlay = await mapSignedUrlsToSources(
            [createdOverlay],
            apiClient,
            teamId,
            eventId
          );
          // notify other directors
          socket.emit(OVERLAY_ADD, { broadcastId });
          return mappedOverlay;
        }
      };
      dispatch(action);
    }
  );
};
